import React from 'react'

export default React.createContext({
  characterOne: null,
  characterTwo: null,
  characterThree: null,
  characterSelected: null,
  gameInSession: false,
  loading: false,
  guestSession: false,
  editingCharacter: false,
  makeCharacterOne: () => { },
  makeCharacterTwo: () => { },
  makeCharacterThree: () => { },
  deleteCharacterOne: () => { },
  deleteCharacterTwo: () => { },
  deleteCharacterThree: () => { },
  cleanAllCharacterSlots: () => { },
  selectCharacter: () => { },
  unselectCharacter: () => {},
  startGameSession: () => { },
  setGuestSessionTrue: () => { },
  setGuestSessionFalse: () => { },
  setEditingCharacterTrue: () => { },
  setEditingCharacterFalse: () => { },
})